export const PAYJP_URL = 'https://js.pay.jp/v2/pay.js';
